import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {Thu} from '../../models/email/thu';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
const apiUrl = `${environment.apiUrl}/api/email/thu`;

@Injectable({
  providedIn: 'root'
})
export class ThuService {
  constructor(public httpService: HttpClient) { }

  public getAll(): Observable<Thu[]> {
    return this.httpService.get<Thu[]>(`${apiUrl}/getall`).pipe(
      map(data => data.map(data => new Thu().deserialize(data)))
    );

  }
  public getAllByNhomThu(nhomThu: number, staffId: number): Observable<Thu[]> {
    return this.httpService.get<Thu[]>(`${apiUrl}/getallnhomthu?nid=${nhomThu}&uid=${staffId}`).pipe(
      map(data => data.map(data => new Thu().deserialize(data)))
    );
  }
  public add(params: Object): Observable<Thu>
  {
    return this.httpService.post(`${apiUrl}/add`, params).pipe(
      map(data => new Thu().deserialize(data)));

  }
  public addByDraftId(id: number): Observable<Thu>
  {
    return this.httpService.get(`${apiUrl}/addbydraft?drid=${id}`).pipe(
      map(data => new Thu().deserialize(data)));

  }
  public update(params: Object): Observable<Thu>
  {
    return this.httpService.post(`${apiUrl}/update`, params).pipe(
      map(data => new Thu().deserialize(data)));

  }
  public replyMail(id: number): Observable<Thu>
  {
    return this.httpService.get(`${apiUrl}/replybymail?drid=${id}`).pipe(
      map(data => new Thu().deserialize(data)));

  }
  public getCountByKeyword(keyword: string, staffId: number, read: number, del: number, status: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword?keyword=${keyword}&uid=${staffId}&rd=${read}&del=${del}&st=${status}`).pipe(
      map(data => Number(data)));
  }
  public getIdByBack(keyword: string, staffId: number, read: number, del: number, status: string, idcurrent: number)
  {
    return this.httpService.get(`${apiUrl}/getidbyback?keyword=${keyword}&uid=${staffId}&rd=${read}&del=${del}&st=${status}&cid=${idcurrent}`).pipe(
      map(data => Number(data)));
  }
  public getIdByNext(keyword: string, staffId: number, read: number, del: number, status: string, idcurrent: number)
  {
    return this.httpService.get(`${apiUrl}/getidbynext?keyword=${keyword}&uid=${staffId}&rd=${read}&del=${del}&st=${status}&cid=${idcurrent}`).pipe(
      map(data => Number(data)));
  }
  public getById(id: number): Observable<Thu>
  {
    return this.httpService.get<Thu>(`${apiUrl}/findbyid/${id}`).pipe(
      map(data => new Thu().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public getByReadId(id: number): Observable<Thu>
  {
    return this.httpService.get<Thu>(`${apiUrl}/findbyreadid/${id}`).pipe(
      map(data => new Thu().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public delete(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/delete/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  public ghimMail(id: number, staffId: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/ghim/${id}?uid=${staffId}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id ghim not found'))
    );
  }
  public unGhimMail(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/unghim/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id unghim not found'))
    );
  }
  public deleteAllByNguoiNhan(id: number, suDung: number, suDungNew: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/deleteallbynguoinhan?id=${id}&sd=${suDung}&sdn=${suDungNew}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  public deleteAllByIds(id: String, suDung: number, suDungNew: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/deleteallbyids?id=${id}&sd=${suDung}&sdn=${suDungNew}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  public readAllByNguoiNhan(id: number, read: number, readNew: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/readallbynguoinhan?id=${id}&rd=${read}&rdn=${readNew}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id read not found'))
    );
  }
  public readAllByIds(id: String, read: number, readNew: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/readallbyids?id=${id}&rd=${read}&rdn=${readNew}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id read not found'))
    );
  }
  findByKeyword(keyword: String): Observable<Thu[]> {
    return this.httpService.get<Thu[]>(`${apiUrl}/findbykeyword?keyword=${keyword}`).pipe(
      map(data => data.map(data => new Thu().deserialize(data)))
    );
  }
  findAllByPaging(keyword: String, staffId: number, read: number, del: number, status: string, page: number, size: number): Observable<Thu[]> {
    return this.httpService.get<Thu[]>(`${apiUrl}/getallpaging?key=${keyword}&uid=${staffId}&rd=${read}&del=${del}&st=${status}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new Thu().deserialize(data)))
    );
  }
  public chenHoSo(id: number, hoSoId: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/chenhoso?id=${id}&hsid=${hoSoId}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id insert not found'))
    );
  }
  public chuyenTrinh(id: number, thuId: number, staffId: number)
  {
    return this.httpService.get(`${apiUrl}/chuyentrinh?id=${id}&tid=${thuId}&uid=${staffId}`).pipe(
      map(data => Number(data)));
  }
  public chuyenGiaoViec(id: number, thuId: number, staffId: number)
  {
    return this.httpService.get(`${apiUrl}/chuyengiaoviec?id=${id}&tid=${thuId}&uid=${staffId}`).pipe(
      map(data => Number(data)));
  }
}
